<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-black-500 mr-3"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
    >
        <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M3 7a2 2 0 012-2h3.586a1 1 0 01.707.293l1.414 1.414A1 1 0 0011.414 7H21a2 2 0 012 2v10a2 2 0 01-2 2H3a2 2 0 01-2-2V7z"
        />
    </svg>
</template>